import VerificationReminder from './VerificationReminder';
import VerificationReminderContainer from './VerificationReminder.container';

export default VerificationReminderContainer(VerificationReminder);
